"use client";
import { jsx as p } from "react/jsx-runtime";
import { css as a } from "@emotion/react";
import c from "@emotion/styled";
import { SPACINGS as o } from "../../tokens/spacings/Spacings.js";
import { forwardRef as d } from "react";
const e = d(
  ({ feHorizontal: t = !1, feSpacing: r = "md", ...m }, s) => /* @__PURE__ */ p(
    i,
    {
      ...m,
      "data-comp": "spacer",
      feHorizontal: t,
      feSpacing: r,
      ref: s
    }
  )
);
e.displayName = "Spacer";
const y = e, i = c.div(({ feHorizontal: t, feSpacing: r }) => {
  if (!r)
    throw new Error("Style error");
  return a`
		height: ${!t && o[r]};
		width: ${t && o[r]};
	`;
});
export {
  y as default
};
